import { createGraphqlFetcher } from '@apis/createFetcher';

const userGroup = `{
    id
    sid
    name
    source
    content
    description
    createTime
    updateTime
    status
    guideType
    count
}`;

const Goal = `{
    id
    sid
    name
    content
    description
    createTime
    updateTime
    createBy
    updateBy
    status
    count
}`;

const EngageV4CreativeTerminal = `{
    id
    type
    status
    popup
    stickybar
    inline
    code
    engageVersionID
}`;

const EngageV4Version = `{
    id
    name
    rate
    controlGroup
    screenshot
    engageID
    terminals ${EngageV4CreativeTerminal}
}`;

const engageConfig = `{
    id
    sid
    name
    status
    createTime
    updateTime
    lastPauseTime
    firstRunTime
    hasForm
    isVersionEvent
    createBy
    updateBy
    hasVariant
    engageVersion
    engageType
    baseURL
    screenshot
    schedule
    conditions
    usergroups ${userGroup}
    versions ${EngageV4Version}
    firstRunABTestTime
    enableABTest
    count
}`;

const engageData = `{
    engageViewCount
    engageView
    engageClick
    engageClickRate
    engageClose
    engageCloseRate
    engageSubmit
    goal {
        goalId
        rate
        name
        number
    }
    avgSessionDuration
    bounceRate
    sessionViewDepth
}`;

const templateSchema = `
    {
        id
        name
        description
        pcThumbnail
        pcWidgets
        pcWidgetLayout
        mobileThumbnail
        mobileWidgets
        mobileWidgetLayout
        deviceType
        type
        tag
        area
        sort
        recommendationLocation
    }
`;

const apis = {
    getPreviewKey: {
        name: 'previewKey',
        query: `mutation previewKey($data: PreviewEngagement!){
            previewKey(data: $data)
        }`
    },
    getListColumns: {
        name: 'accountProfile',
        query: `query accountProfile($where: AccountProfileUniqueInput!){
            accountProfile(where:$where) {
                campaignReportColumns
            }
        }`
    },
    updateAccountProfile: {
        name: 'updateAccountProfile',
        query: `mutation updateAccountProfile($data: AccountProfileInput!, $where: AccountProfileUniqueInput!){
            updateAccountProfile(data:$data, where:$where) {
                campaignReportColumns
            }
        }`
    },
    getAllGoalList: {
        name: 'getGoals',
        query: `query getGoals($where: GoalListWhereUniqueInput!){
            goals(where:$where) {
                id
                name
                content
                description
                engagements
                currentResult
                lastResult
            }
        }`
    },
    getTemplateInfoByID: {
        name: 'getEngageV4TemplateById',
        query: `
            query getEngageV4TemplateById($id: ID!){
                getEngageV4TemplateById(id: $id) ${templateSchema}
            }
        `
    }
};

export default createGraphqlFetcher(apis);
